
import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import SequencerOperation from "models/audioEditor/sequencerOperation/SequencerOperation";
import RSVP from "rsvp";


const DeleteSequencerNodeOperation =  SequencerOperation.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        SequencerOperation.apply(this, [attributes, options]);
    },

    execute : function(sequencerNode){
        const nextNode =  sequencerNode.getNext();
        const previousNode =  this.getPreviousNodeLinkedTo(sequencerNode);
        this.removeAudioNode(sequencerNode);
        this.getSequencer().getHistoryManagement().addDeleteSequencerNodeLog(sequencerNode, previousNode, nextNode, previousNode?false: true);
    },

    undo : function(sequencerDeleteSequencerNodeLog ){
        const sequencerNode = sequencerDeleteSequencerNodeLog.getSequencerNode();
        if(sequencerDeleteSequencerNodeLog.getPreviousNode()){
            return this.insertAudioNodeArray([sequencerNode], sequencerDeleteSequencerNodeLog.getPreviousNode());
        }
        if(sequencerDeleteSequencerNodeLog.getNextNode()){
            return this.insertAudioNodeArray([sequencerNode], sequencerDeleteSequencerNodeLog.getNextNode(), true);
        }
        return this.insertAudioNodeArray([sequencerNode]);
    },

    redo: function(sequencerDeleteSequencerNodeLog){
        this.removeAudioNode(sequencerDeleteSequencerNodeLog.getSequencerNode());
    },

});


export default DeleteSequencerNodeOperation;
